var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:_vm.b()},[_c('input',{class:_vm.b('input'),attrs:{"type":"file","multiple":_vm.multiple,"accept":_vm.accept},on:{"change":_vm.onChange}}),_c('v-icon',{staticClass:"primary--text",class:_vm.b('icon')},[_vm._v("mdi-upload")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }